import { Mark } from 'tiptap';

import { toggleMark, markInputRule, markPasteRule } from 'tiptap-commands'

export default class Box extends Mark {
    get name() {
        return "NEW_BOX"
    }
    get schema() {
        return {
            content: 'block',
            parseDOM: [{ tag: 'code' }],
            toDOM: () => ['code', 0],
        }
    }
    // keys({ type }) {
    //     return {
    //         'Mod-[': toggleMark(type),
    //     }
    // }
    commands({ type }) {
        return () => toggleMark(type)
    }







}
